/* «Поддержка» — контакты и правила обмена. */
import Modal from './Modal.jsx';

export default function SupportModal({ onClose }) {
  return (
    <Modal title="Поддержка" sub="Отвечаем в Telegram обычно за пару минут" onClose={onClose}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div className="delivery-card">
          <div className="delivery-card__row"><span>Telegram</span><b>@saints_support</b></div>
          <div className="delivery-card__row"><span>Почта</span><b>help@saints.store</b></div>
          <div className="delivery-card__row"><span>Часы работы</span><b>Пн–Вс 10:00–22:00 МСК</b></div>
          <div className="delivery-card__row"><span>Обмен и возврат</span><b>14 дней, бесплатно</b></div>
        </div>
        <p className="u-muted" style={{ fontSize: 14, lineHeight: 1.6 }}>
          Заказ едет СДЭКом: после сборки придёт трек-номер, по нему можно отслеживать посылку
          на сайте перевозчика или в приложении.
        </p>
      </div>
    </Modal>
  );
}
